import React from 'react';

import { SVGIcon } from '../../UIKit/index';

export default function DCNoAnalytics(props) {
    return (
        <SVGIcon {...props} viewBox="0 0 273.123 213.039">
            <g transform="translate(-935 -88)">
                <ellipse
                    cx="87.5"
                    cy="17.5"
                    rx="87.5"
                    ry="17.5"
                    transform="translate(989.363 266.039)"
                    fill="#f5f5f5"
                />
                <g
                    transform="translate(989.363 148.804)"
                    fill="#fff"
                    stroke="#405d63"
                    strokeWidth="2"
                >
                    <rect width="178.969" height="128.821" rx="6" stroke="none" />
                    <rect x="1" y="1" width="176.969" height="126.821" rx="5" fill="none" />
                </g>
                <g
                    transform="translate(998.856 159.14)"
                    fill="#fff"
                    stroke="#405d63"
                    strokeWidth="2"
                >
                    <rect width="160.353" height="107.576" rx="2" stroke="none" />
                    <rect x="1" y="1" width="158.353" height="105.576" rx="1" fill="none" />
                </g>
                <g transform="translate(946 273.376)" fill="#fff">
                    <path
                        d="M 245.3007965087891 13.16345691680908 L 7.999990463256836 13.16345691680908 C 4.140190601348877 13.16345691680908 0.9999906420707703 10.0232572555542 0.9999906420707703 6.163456916809082 L 0.9999906420707703 0.9999903440475464 L 252.3007965087891 0.9999903440475464 L 252.3007965087891 6.163456916809082 C 252.3007965087891 10.0232572555542 249.1605834960938 13.16345691680908 245.3007965087891 13.16345691680908 Z"
                        stroke="none"
                    />
                    <path
                        d="M 1.999984741210938 1.999990463256836 L 1.999984741210938 6.163456916809082 C 1.999984741210938 9.471857070922852 4.69158935546875 12.16345691680908 7.999984741210938 12.16345691680908 L 245.3007965087891 12.16345691680908 C 248.6091918945313 12.16345691680908 251.3007965087891 9.471857070922852 251.3007965087891 6.163456916809082 L 251.3007965087891 1.999990463256836 L 1.999984741210938 1.999990463256836 M -1.52587890625e-05 -9.5367431640625e-06 L 253.3007965087891 -9.5367431640625e-06 L 253.3007965087891 6.163456916809082 C 253.3007965087891 10.58172416687012 249.7190551757813 14.16345691680908 245.3007965087891 14.16345691680908 L 7.999984741210938 14.16345691680908 C 3.58172607421875 14.16345691680908 -1.52587890625e-05 10.58172416687012 -1.52587890625e-05 6.163456916809082 L -1.52587890625e-05 -9.5367431640625e-06 Z"
                        stroke="none"
                        fill="#405d63"
                    />
                </g>
                <g transform="translate(-5)">
                    <g transform="translate(1178 245)" fill="#405d63" stroke="#fff" strokeWidth="3">
                        <circle cx="5" cy="5" r="5" stroke="none" />
                        <circle cx="5" cy="5" r="3.5" fill="none" />
                    </g>
                    <g transform="translate(1178 174)" fill="#405d63" stroke="#fff" strokeWidth="4">
                        <rect width="10" height="65" rx="5" stroke="none" />
                        <rect x="2" y="2" width="6" height="61" rx="3" fill="none" />
                    </g>
                </g>
                <g transform="translate(-204)">
                    <g transform="translate(1178 245)" fill="#405d63" stroke="#fff" strokeWidth="3">
                        <circle cx="5" cy="5" r="5" stroke="none" />
                        <circle cx="5" cy="5" r="3.5" fill="none" />
                    </g>
                    <g transform="translate(1178 174)" fill="#405d63" stroke="#fff" strokeWidth="4">
                        <rect width="10" height="65" rx="5" stroke="none" />
                        <rect x="2" y="2" width="6" height="61" rx="3" fill="none" />
                    </g>
                </g>
                <g transform="translate(-263 -352)">
                    <g transform="translate(1256 466)" fill="none">
                        <path d="M13,0A13,13,0,1,1,0,13,13,13,0,0,1,13,0Z" stroke="none" />
                        <path
                            d="M 13 2 C 10.06179046630859 2 7.299449920654297 3.144199371337891 5.221830368041992 5.221830368041992 C 3.144199371337891 7.299449920654297 2 10.06179046630859 2 13 C 2 15.93820953369141 3.144199371337891 18.7005500793457 5.221830368041992 20.77816963195801 C 7.299449920654297 22.85580062866211 10.06179046630859 24 13 24 C 15.93820953369141 24 18.7005500793457 22.85580062866211 20.77816963195801 20.77816963195801 C 22.85580062866211 18.7005500793457 24 15.93820953369141 24 13 C 24 10.06179046630859 22.85580062866211 7.299449920654297 20.77816963195801 5.221830368041992 C 18.7005500793457 3.144199371337891 15.93820953369141 2 13 2 M 13 0 C 20.1796989440918 0 26 5.82029914855957 26 13 C 26 20.1796989440918 20.1796989440918 26 13 26 C 5.82029914855957 26 0 20.1796989440918 0 13 C 0 5.82029914855957 5.82029914855957 0 13 0 Z"
                            stroke="none"
                            fill="#405d63"
                        />
                    </g>
                    <g transform="translate(1394 440)" fill="none">
                        <path d="M17,0A17,17,0,1,1,0,17,17,17,0,0,1,17,0Z" stroke="none" />
                        <path
                            d="M 17 2 C 12.99336051940918 2 9.226520538330078 3.560270309448242 6.393400192260742 6.393400192260742 C 3.560270309448242 9.226520538330078 2 12.99336051940918 2 17 C 2 21.00664138793945 3.560270309448242 24.77347946166992 6.393400192260742 27.60659980773926 C 9.226520538330078 30.43972969055176 12.99336051940918 32 17 32 C 21.00664138793945 32 24.77347946166992 30.43972969055176 27.60659980773926 27.60659980773926 C 30.43972969055176 24.77347946166992 32 21.00664138793945 32 17 C 32 12.99336051940918 30.43972969055176 9.226520538330078 27.60659980773926 6.393400192260742 C 24.77347946166992 3.560270309448242 21.00664138793945 2 17 2 M 17 0 C 26.38883972167969 0 34 7.611160278320313 34 17 C 34 26.38883972167969 26.38883972167969 34 17 34 C 7.611160278320313 34 0 26.38883972167969 0 17 C 0 7.611160278320313 7.611160278320313 0 17 0 Z"
                            stroke="none"
                            fill="#405d63"
                        />
                    </g>
                    <g transform="translate(1304 469)" fill="#405d63" stroke="#fff" strokeWidth="4">
                        <rect width="10" height="25" stroke="none" />
                        <rect x="2" y="2" width="6" height="21" fill="none" />
                    </g>
                    <g transform="translate(1319 464)" fill="#405d63" stroke="#fff" strokeWidth="4">
                        <rect width="10" height="30" stroke="none" />
                        <rect x="2" y="2" width="6" height="26" fill="none" />
                    </g>
                    <g transform="translate(1334 459)" fill="#405d63" stroke="#fff" strokeWidth="4">
                        <rect width="10" height="35" stroke="none" />
                        <rect x="2" y="2" width="6" height="31" fill="none" />
                    </g>
                    <g transform="translate(1349 454)" fill="#405d63" stroke="#fff" strokeWidth="4">
                        <rect width="10" height="40" stroke="none" />
                        <rect x="2" y="2" width="6" height="36" fill="none" />
                    </g>
                    <g transform="translate(1364 449)" fill="#405d63" stroke="#fff" strokeWidth="4">
                        <rect width="10" height="45" stroke="none" />
                        <rect x="2" y="2" width="6" height="41" fill="none" />
                    </g>
                    <g transform="translate(550 -154)" opacity="0.5">
                        <g
                            transform="translate(902 615)"
                            fill="#fff"
                            stroke="#c3c5c4"
                            strokeWidth="1"
                        >
                            <rect width="2" height="10" rx="1" stroke="none" />
                            <rect x="0.5" y="0.5" width="1" height="9" rx="0.5" fill="none" />
                        </g>
                        <g
                            transform="translate(908 619) rotate(90)"
                            fill="#fff"
                            stroke="#c3c5c4"
                            strokeWidth="1"
                        >
                            <rect width="2" height="10" rx="1" stroke="none" />
                            <rect x="0.5" y="0.5" width="1" height="9" rx="0.5" fill="none" />
                        </g>
                    </g>
                    <g
                        transform="translate(1459 448)"
                        fill="#fff"
                        stroke="#c3c5c4"
                        strokeWidth="1.6"
                        opacity="0.5"
                    >
                        <circle cx="4.5" cy="4.5" r="4.5" stroke="none" />
                        <circle cx="4.5" cy="4.5" r="3.7" fill="none" />
                    </g>
                </g>
                <g transform="translate(11024 3913)" fill="#405d63">
                    <path
                        d="M -9884.9990234375 -3659.998779296875 L -10003.9990234375 -3659.998779296875 C -10004.115234375 -3659.998779296875 -10004.2333984375 -3660.00390625 -10004.3515625 -3660.01416015625 L -10004.5322265625 -3660.029541015625 L -10004.7119140625 -3660.0126953125 C -10004.80859375 -3660.00341796875 -10004.90625 -3659.998779296875 -10005.0009765625 -3659.998779296875 C -10006.654296875 -3659.998779296875 -10008 -3661.345458984375 -10008 -3663.00048828125 L -10008 -3683 C -10008 -3684.65380859375 -10006.654296875 -3685.999267578125 -10005.0009765625 -3685.999267578125 C -10003.345703125 -3685.999267578125 -10001.9990234375 -3684.65380859375 -10001.9990234375 -3683 L -10001.9990234375 -3667.999755859375 L -10001.9990234375 -3665.999755859375 L -9999.9990234375 -3665.999755859375 L -9890.0009765625 -3665.999755859375 L -9888.0009765625 -3665.999755859375 L -9888.0009765625 -3667.999755859375 L -9888.0009765625 -3722.998779296875 C -9888.0009765625 -3724.654052734375 -9886.654296875 -3726.000732421875 -9884.9990234375 -3726.000732421875 C -9883.345703125 -3726.000732421875 -9882 -3724.654052734375 -9882 -3722.998779296875 L -9882 -3663.00048828125 C -9882 -3661.345458984375 -9883.345703125 -3659.998779296875 -9884.9990234375 -3659.998779296875 Z"
                        stroke="none"
                    />
                    <path
                        d="M -9884.9990234375 -3661.998779296875 C -9884.4482421875 -3661.998779296875 -9884 -3662.4482421875 -9884 -3663.00048828125 L -9884 -3722.998779296875 C -9884 -3723.55126953125 -9884.4482421875 -3724.000732421875 -9884.9990234375 -3724.000732421875 C -9885.5517578125 -3724.000732421875 -9886.0009765625 -3723.55126953125 -9886.0009765625 -3722.998779296875 L -9886.0009765625 -3667.999755859375 L -9886.0009765625 -3663.999755859375 L -9890.0009765625 -3663.999755859375 L -9999.9990234375 -3663.999755859375 L -10003.9990234375 -3663.999755859375 L -10003.9990234375 -3667.999755859375 L -10003.9990234375 -3683 C -10003.9990234375 -3683.551025390625 -10004.4482421875 -3683.999267578125 -10005.0009765625 -3683.999267578125 C -10005.5517578125 -3683.999267578125 -10006 -3683.551025390625 -10006 -3683 L -10006 -3663.00048828125 C -10006 -3662.4482421875 -10005.5517578125 -3661.998779296875 -10005.0009765625 -3661.998779296875 C -10004.96875 -3661.998779296875 -10004.9345703125 -3662.00048828125 -10004.900390625 -3662.003662109375 L -10004.5400390625 -3662.037841796875 L -10004.1806640625 -3662.0068359375 C -10004.119140625 -3662.00146484375 -10004.0576171875 -3661.998779296875 -10003.9990234375 -3661.998779296875 L -9884.9990234375 -3661.998779296875 M -9884.9990234375 -3657.998779296875 L -10003.9990234375 -3657.998779296875 C -10004.17578125 -3657.998779296875 -10004.3505859375 -3658.006591796875 -10004.5234375 -3658.021484375 C -10004.6806640625 -3658.006591796875 -10004.83984375 -3657.998779296875 -10005.0009765625 -3657.998779296875 C -10007.76171875 -3657.998779296875 -10010 -3660.23974609375 -10010 -3663.00048828125 L -10010 -3683 C -10010 -3685.760986328125 -10007.76171875 -3687.999267578125 -10005.0009765625 -3687.999267578125 C -10002.23828125 -3687.999267578125 -9999.9990234375 -3685.760986328125 -9999.9990234375 -3683 L -9999.9990234375 -3667.999755859375 L -9890.0009765625 -3667.999755859375 L -9890.0009765625 -3722.998779296875 C -9890.0009765625 -3725.76220703125 -9887.7626953125 -3728.000732421875 -9884.9990234375 -3728.000732421875 C -9882.23828125 -3728.000732421875 -9880 -3725.76220703125 -9880 -3722.998779296875 L -9880 -3663.00048828125 C -9880 -3660.23974609375 -9882.23828125 -3657.998779296875 -9884.9990234375 -3657.998779296875 Z"
                        stroke="none"
                        fill="#fff"
                    />
                </g>
                <g transform="translate(1065.686 135.877)">
                    <g transform="translate(13.162)">
                        <g transform="translate(0)">
                            <path
                                d="M139.243.88A3.609,3.609,0,0,0,136.9,0H114.566a3.26,3.26,0,0,0,0,6.52l14.408-.033L93.736,41.758,81.382,29.338a3.156,3.156,0,0,0-4.629,0L14.165,91.991A3.274,3.274,0,0,0,18.7,96.718c.033-.033.065-.065.1-.065L46.82,68.626,79.1,36.347,91.454,48.668a3.336,3.336,0,0,0,2.314.913,3.4,3.4,0,0,0,2.314-.913l37.585-37.585-.033,14.376a3.214,3.214,0,0,0,3.227,3.227h.033a3.214,3.214,0,0,0,3.26-3.195v-.033l.033-22.3A3.347,3.347,0,0,0,139.243.88Z"
                                transform="translate(-13.162)"
                                fill="#405d63"
                                stroke="#fff"
                                strokeWidth="4.5"
                            />
                        </g>
                    </g>
                </g>
                <g transform="translate(37 -366)" opacity="0.5">
                    <g transform="translate(902 615)" fill="#fff" stroke="#c3c5c4" strokeWidth="1">
                        <rect width="2" height="10" rx="1" stroke="none" />
                        <rect x="0.5" y="0.5" width="1" height="9" rx="0.5" fill="none" />
                    </g>
                    <g
                        transform="translate(908 619) rotate(90)"
                        fill="#fff"
                        stroke="#c3c5c4"
                        strokeWidth="1"
                    >
                        <rect width="2" height="10" rx="1" stroke="none" />
                        <rect x="0.5" y="0.5" width="1" height="9" rx="0.5" fill="none" />
                    </g>
                </g>
                <g transform="translate(290 -389)" opacity="0.5">
                    <g
                        id="Rectangle_593-3"
                        data-name="Rectangle 593"
                        transform="translate(902 615)"
                        fill="#fff"
                        stroke="#c3c5c4"
                        strokeWidth="1"
                    >
                        <rect width="2" height="10" rx="1" stroke="none" />
                        <rect x="0.5" y="0.5" width="1" height="9" rx="0.5" fill="none" />
                    </g>
                    <g
                        transform="translate(908 619) rotate(90)"
                        fill="#fff"
                        stroke="#c3c5c4"
                        strokeWidth="1"
                    >
                        <rect width="2" height="10" rx="1" stroke="none" />
                        <rect x="0.5" y="0.5" width="1" height="9" rx="0.5" fill="none" />
                    </g>
                </g>
                <g
                    transform="translate(946 236)"
                    fill="#fff"
                    stroke="#c3c5c4"
                    strokeWidth="1.6"
                    opacity="0.5"
                >
                    <circle cx="4.5" cy="4.5" r="4.5" stroke="none" />
                    <circle cx="4.5" cy="4.5" r="3.7" fill="none" />
                </g>
                <g
                    transform="translate(1199 213)"
                    fill="#fff"
                    stroke="#c3c5c4"
                    strokeWidth="1.6"
                    opacity="0.5"
                >
                    <circle cx="4.5" cy="4.5" r="4.5" stroke="none" />
                    <circle cx="4.5" cy="4.5" r="3.7" fill="none" />
                </g>
            </g>
        </SVGIcon>
    );
}
